import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService {
  private overlayElement?: HTMLDivElement;

  handleError(error: any): void {
    const message =
      error?.message ||
      error?.toString?.() ||
      error?.rejection?.message ||
      '';

    if (message.includes('Could not find column with id')) {
      this.openResetColumnsOverlay();
      return;
    }

    console.error(error);
  }

  private openResetColumnsOverlay(): void {
    if (this.overlayElement) {
      return;
    }

    const overlay = document.createElement('div');
    overlay.className = 'reset-columns-overlay-backdrop';

    overlay.innerHTML = `
      <div class="reset-columns-overlay-box">
        <h2>Tabellenspalten zurücksetzen?</h2>

        <p>
          Die gespeicherten Tabellenspalten passen nicht mehr zur aktuellen Version.
        </p>

        <p>
          Möchtest du die gespeicherten Spalten löschen?
        </p>

        <div class="reset-columns-overlay-actions">
          <button type="button" class="reset-columns-cancel">
            Abbrechen
          </button>

          <button type="button" class="reset-columns-delete">
            Löschen
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    this.overlayElement = overlay;

    overlay
      .querySelector('.reset-columns-cancel')
      ?.addEventListener('click', () => this.closeOverlay());

    overlay
      .querySelector('.reset-columns-delete')
      ?.addEventListener('click', () => this.resetColumns());
  }

  private resetColumns(): void {
    localStorage.removeItem('tableColumns');

    this.closeOverlay();

    window.location.reload();
  }

  private closeOverlay(): void {
    this.overlayElement?.remove();
    this.overlayElement = undefined;
  }
}
